<template>
  <div
    class="view-file"
    v-if="seen"
    @click="close_box"
    @contextmenu="notallowed"
    v-click-outside="close"
  >
    <div class="header">
      <div class="left text-truncate">
        <span @click="close_box">
          <svg
            style="width: 24px; height: 24px"
            viewBox="0 0 24 24"
            @click="close_box"
            class="close"
          >
            <path
              fill="#fff"
              d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z"
            />
          </svg>
        </span>
        <span>
          {{ name }}
        </span>
      </div>
      <div class="right">
        <span @click="print">
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path
              fill="#fff"
              d="M18,3H6V7H18M19,12A1,1 0 0,1 18,11A1,1 0 0,1 19,10A1,1 0 0,1 20,11A1,1 0 0,1 19,12M16,19H8V14H16M19,8H5A3,3 0 0,0 2,11V17H6V21H18V17H22V11A3,3 0 0,0 19,8Z"
            />
          </svg>
        </span>
        <span @click="download">
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path fill="#fff" d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
          </svg>
        </span>
        <!--<span>
                    <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                        <path fill="#fff" d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                    </svg>
                </span>-->
        <button class="btn d-md-none" @click="close">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.59093 6.99999L13.0441 2.54687C13.2554 2.3359 13.3743 2.04961 13.3745 1.75099C13.3748 1.45237 13.2564 1.16587 13.0455 0.954529C12.8345 0.743185 12.5482 0.624305 12.2496 0.624041C11.951 0.623778 11.6645 0.742152 11.4531 0.953123L6.99999 5.40625L2.54687 0.953123C2.33553 0.741779 2.04888 0.623047 1.75 0.623047C1.45111 0.623047 1.16447 0.741779 0.953123 0.953123C0.741779 1.16447 0.623047 1.45111 0.623047 1.75C0.623047 2.04888 0.741779 2.33553 0.953123 2.54687L5.40625 6.99999L0.953123 11.4531C0.741779 11.6645 0.623047 11.9511 0.623047 12.25C0.623047 12.5489 0.741779 12.8355 0.953123 13.0469C1.16447 13.2582 1.45111 13.3769 1.75 13.3769C2.04888 13.3769 2.33553 13.2582 2.54687 13.0469L6.99999 8.59374L11.4531 13.0469C11.6645 13.2582 11.9511 13.3769 12.25 13.3769C12.5489 13.3769 12.8355 13.2582 13.0469 13.0469C13.2582 12.8355 13.3769 12.5489 13.3769 12.25C13.3769 11.9511 13.2582 11.6645 13.0469 11.4531L8.59093 6.99999Z"
              fill="#677888"
            />
          </svg>
        </button>
      </div>
    </div>
    <div class="img">
      <span @click="prevctl" class="d-none d-md-inline">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24 6C14.0625 6 6 14.0625 6 24C6 33.9375 14.0625 42 24 42C33.9375 42 42 33.9375 42 24C42 14.0625 33.9375 6 24 6Z"
            stroke="white"
            stroke-width="2"
            stroke-miterlimit="10"
          />
          <path
            d="M27.75 33L18.75 24L27.75 15"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
      <div class="img-holder position-relative" @click="!zoomed && close">
        <!--<button @click="close_box" class="btn position-absolute">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.59093 6.99999L13.0441 2.54687C13.2554 2.3359 13.3743 2.04961 13.3745 1.75099C13.3748 1.45237 13.2564 1.16587 13.0455 0.954529C12.8345 0.743185 12.5482 0.624305 12.2496 0.624041C11.951 0.623778 11.6645 0.742152 11.4531 0.953123L6.99999 5.40625L2.54687 0.953123C2.33553 0.741779 2.04888 0.623047 1.75 0.623047C1.45111 0.623047 1.16447 0.741779 0.953123 0.953123C0.741779 1.16447 0.623047 1.45111 0.623047 1.75C0.623047 2.04888 0.741779 2.33553 0.953123 2.54687L5.40625 6.99999L0.953123 11.4531C0.741779 11.6645 0.623047 11.9511 0.623047 12.25C0.623047 12.5489 0.741779 12.8355 0.953123 13.0469C1.16447 13.2582 1.45111 13.3769 1.75 13.3769C2.04888 13.3769 2.33553 13.2582 2.54687 13.0469L6.99999 8.59374L11.4531 13.0469C11.6645 13.2582 11.9511 13.3769 12.25 13.3769C12.5489 13.3769 12.8355 13.2582 13.0469 13.0469C13.2582 12.8355 13.3769 12.5489 13.3769 12.25C13.3769 11.9511 13.2582 11.6645 13.0469 11.4531L8.59093 6.99999Z"
              fill="#677888"
            />
          </svg>
        </button>-->

        <!--
        <img
          ref="img"
          :fsrc="path"
          src="https://images.unsplash.com/photo-1629581477374-9237dc216942?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8fHx8fHx8MTYzMjIyMzQ2Ng&ixlib=rb-1.2.1&q=80&w=1080"
        />-->

        <div v-if="isLoading" class="loader">
          <svg
            width="120px"
            height="120px"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
            class="lds-dual-ring"
            style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%"
          >
            <circle
              cx="50"
              cy="50"
              fill="none"
              stroke-linecap="round"
              r="20"
              stroke-width="4"
              stroke="#039aed"
              stroke-dasharray="31.41592653589793 31.41592653589793"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                calcMode="linear"
                values="0 50 50;360 50 50"
                keyTimes="0;1"
                dur="1s"
                begin="0s"
                repeatCount="indefinite"
              ></animateTransform>
            </circle>
          </svg>
        </div>

        <v-zoomer
          :class="{ invisible: isLoading }"
          ref="zoomer"
          :aspect-ratio="imageAspectRatio"
          :max-scale="10"
          :zooming-elastic="false"
          :zoomed.sync="zoomed"
        >
          <img
            :src="path"
            style="object-fit: contain; width: 100%; height: 100%"
            @load="onImageLoad"
          />
        </v-zoomer>
      </div>
      <span @click="nextctl" class="d-none d-md-inline">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 24C6 33.9375 14.0625 42 24 42C33.9375 42 42 33.9375 42 24C42 14.0625 33.9375 6 24 6C14.0625 6 6 14.0625 6 24Z"
            stroke="white"
            stroke-width="2"
            stroke-miterlimit="10"
          />
          <path
            d="M20.25 33L29.25 24L20.25 15"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </div>
    <div class="footer d-none d-md-flex">
      <div class="floor">
        <span @click="$refs.zoomer.zoomOut()" title="Zoom-out">
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path fill="#fff" d="M19,13H5V11H19V13Z" />
          </svg>
        </span>
        <span @click="$refs.zoomer.reset()" title="Reset">
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path
              fill="#fff"
              d="M15.5,14H14.71L14.43,13.73C15.41,12.59 16,11.11 16,9.5A6.5,6.5 0 0,0 9.5,3A6.5,6.5 0 0,0 3,9.5A6.5,6.5 0 0,0 9.5,16C11.11,16 12.59,15.41 13.73,14.43L14,14.71V15.5L19,20.5L20.5,19L15.5,14M9.5,14C7,14 5,12 5,9.5C5,7 7,5 9.5,5C12,5 14,7 14,9.5C14,12 12,14 9.5,14M7,9H12V10H7V9Z"
            />
          </svg>
        </span>
        <span @click="$refs.zoomer.zoomIn()" title="Zoom-in">
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path fill="#fff" d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
          </svg>
        </span>
      </div>
    </div>

    <div class="mobile-footer">
      <svg
        @click="download"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.0001 11H23.5001C24.1632 11 24.799 11.2634 25.2679 11.7322C25.7367 12.2011 26.0001 12.837 26.0001 13.5V26.5C26.0001 27.163 25.7367 27.7989 25.2679 28.2678C24.799 28.7366 24.1632 29 23.5001 29H8.50012C7.83708 29 7.2012 28.7366 6.73235 28.2678C6.26351 27.7989 6.00012 27.163 6.00012 26.5V13.5C6.00012 12.837 6.26351 12.2011 6.73235 11.7322C7.2012 11.2634 7.83708 11 8.50012 11H11.0001"
          stroke="#677888"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11 17L16 22L21 17"
          stroke="#677888"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.0001 3V21"
          stroke="#677888"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div class="file-nav">
        <svg
          @click="prevctl"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 4C9.375 4 4 9.375 4 16C4 22.625 9.375 28 16 28C22.625 28 28 22.625 28 16C28 9.375 22.625 4 16 4Z"
            stroke="#677888"
            stroke-width="2"
            stroke-miterlimit="10"
          />
          <path
            d="M18.5 22L12.5 16L18.5 10"
            stroke="#677888"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <svg
          @click="nextctl"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="transform: rotateY(180deg)"
        >
          <path
            d="M16 4C9.375 4 4 9.375 4 16C4 22.625 9.375 28 16 28C22.625 28 28 22.625 28 16C28 9.375 22.625 4 16 4Z"
            stroke="#677888"
            stroke-width="2"
            stroke-miterlimit="10"
          />
          <path
            d="M18.5 22L12.5 16L18.5 10"
            stroke="#677888"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
span {
  margin: 0;
}

.loader {
  position: fixed;
  width: 25%;
  height: 25%;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
}
.vue-zoomer {
  width: 950px;
  height: 75vh;
  max-width: calc(100vw - 2rem);
}
.mobile-footer {
  display: none;
}
@media only screen and (max-width: 960px) {
  .view-file {
    height: calc(var(--vh, 1vh) * 100 - 4.5rem);
    bottom: 0;
    position: fixed;
    top: unset;
    background-color: #fff;
  }

  .view-file {
    .header {
      background: unset;
      color: #677888;
      border-bottom: 1px solid #ced8e1;
      padding: 0 1rem;
      gap: 1.5rem;
    }

    span {
      color: #677888;
    }

    .img-holder {
      height: 60vh !important;
      //background: red;
    }
  }

  .view-file {
    .left,
    .right {
      margin: 0;
    }

    .left .close {
      display: none;
    }

    .right span {
      display: none;
    }
  }

  .vue-zoomer {
    height: 55vh !important;
  }

  .mobile-footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 4.5rem;
    padding: 0 1.5rem;
    border-top: 1px solid #ced8e1;

    .file-nav {
      display: flex;
      gap: 1rem;
    }
  }
}
</style>
<script>
import { setTimeout } from "timers";
import config from "@/services/config";
import cookies from "@/services/cookies";
import VueZoomer from "vue-zoomer/src";
import ClickOutside from "vue-click-outside";

export default {
  components: {
    VZoomer: VueZoomer.Zoomer,
  },
  data() {
    return {
      name: "",
      seen: false,
      index: "",
      id: "",
      path: "",
      download_url:
        process.env.VUE_APP_NODE_ENV === "development"
          ? process.env.VUE_APP_CLIENT_URL
          : process.env.VUE_APP_HTTP + "://" + process.env.VUE_APP_URL,
      default_height: 0,
      default_width: 0,
      points: 1,
      zoomed: false,
      imageAspectRatio: 1,
      isLoading: false,
      // showImage: true,
    };
  },
  methods: {
    onImageLoad(e) {
      const img = e.target;
      this.imageAspectRatio = img.naturalWidth / img.naturalHeight;
    },
    isImage(file) {
      try {
        let ext = file.extname ? file.extname : " ";
        if (ext) {
          ext = ext.split(".");
          ext = ext[ext.length - 1];
        }
        return (
          ext.toLowerCase() === "jpg" ||
          ext.toLowerCase() === "png" ||
          ext.toLowerCase() === "PNG" ||
          ext.toLowerCase() === "jpeg" ||
          ext.toLowerCase() === "JPG" ||
          ext.toLowerCase() === "JPEG" ||
          ext.toLowerCase() === "gif" ||
          ext.toLowerCase() === "GIF"
        );
      } catch (err) {
        return false;
      }
    },
    logincall() {
      this.$parent.logincall();
    },
    loadImage() {
      if (this.imagesFromStore[this.index] === undefined) {
        return;
      } else {
        this.isLoading = true;
        if (this.imagesFromStore[this.index].type === "image") {
          this.name =
            this.str_text(this.imagesFromStore[this.index].dir) +
            this.imagesFromStore[this.index].extname;

          let data = {
            token: cookies.getCookie("token"),
            id: this.imagesFromStore[this.index].id,
            db: this.imagesFromStore[this.index].db,
          };

          this.id = data.id;
          let that = this;

          this.$socket.emit("loadimage", data, function (data) {
            if (data.data === true) {
              that.path =
                process.env.VUE_APP_NODE_ENV === "development"
                  ? process.env.VUE_APP_HTTP +
                    "://" +
                    config.origin +
                    ":" +
                    process.env.VUE_APP_PORT +
                    "/loadimage/" +
                    that.id
                  : process.env.VUE_APP_HTTP +
                    "://" +
                    config.origin +
                    "/loadimage/" +
                    that.id
              /*setTimeout(function () {
                that.default_height = that.$refs.img.height;
                that.default_width = that.$refs.img.width;
              }, 1000);*/
            }

            if (data.data === false) {
              that.seen = false;
              that.logincall();
              that.$router.push('/login')
            }

            that.isLoading = false;
          });
        }
      }
    },
    nextctl() {
      if (this.index === this.imagesFromStore.length - 1) return;
      this.index += 1;
      this.loadImage();
    },
    prevctl() {
      if (this.index === 0) return;
      this.index -= 1;
      this.loadImage();
    },
    str_text(str) {
      return str.length > 38 ? str.substr(0, 38) + "..." : str;
    },
    print() {
      window.open("/print-image/" + this.id);
    },
    download() {
      let id = this.id;
      let token = cookies.getCookie("token");

      let a = document.createElement("a");
      a.setAttribute("download", true);
      a.setAttribute(
        "href",
        this.download_url + "/download?id=" + id + "&token=" + token
      );
      a.hidden = true;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    zoomin() {},
    reset() {
      this.$refs.img.height = this.default_height;
      this.$refs.img.width = this.default_width;
    },
    zoomout() {
      if (this.$refs.img.height > this.$refs.img.width) {
        // console.log('height')
        // console.log(this.$refs.img.height / this.$refs.img.width)
      } else {
        // console.log(this.points)
        // console.log('width')
        // console.log(this.$refs.img.width / this.$refs.img.height)
        let ratio = this.$refs.img.width / this.$refs.img.height;
        // console.log(ratio * this.points)
        // console.log((ratio * this.points) * this.$refs.img.height)
        this.$refs.img.height = ratio * this.points * this.$refs.img.height;
        this.$refs.img.width = ratio * this.points * this.$refs.img.width;
        this.points += 1;
      }
      //this.$refs.img.height = (this.$refs.img.height/this.$refs.img.width) * this.$refs.img.height
      //this.$refs.img.width = (this.$refs.img.height/this.$refs.img.width) * this.$refs.img.width
    },
    load(index, id) {
      // console.log(index, id);
      // console.log("DRA");
      // console.log(this.imagesFromStore);
      this.path = "";
      this.index =
        this.$store.getters.DIRECTORY_CHILDREN[index].db == "sharedfiles" ||
        this.$store.getters.DIRECTORY_CHILDREN[index].db == "sharedwithme"
          ? this.imagesFromStore.findIndex((el) => el.file_id === id)
          : this.imagesFromStore.findIndex((el) => el.id === id);
      // console.log(this.index);
      this.id = id;
      this.seen = true;
      this.name =
        this.str_text(this.imagesFromStore[this.index].dir) +
        this.imagesFromStore[this.index].extname;

      let that = this;

      let data = {
        token: cookies.getCookie("token"),
        id: id,
        db: this.imagesFromStore[this.index].db,
      };
      // console.log("data for socket", data);

      this.$socket.emit("loadimage", data, function (data) {
        // console.log(data)
        if (data.data === true) {
          that.seen = true
          that.path =
            process.env.VUE_APP_NODE_ENV === "development"
              ? process.env.VUE_APP_HTTP +
                "://" +
                config.origin +
                ":" +
                process.env.VUE_APP_PORT +
                "/loadimage/" +
                that.id
              : process.env.VUE_APP_HTTP +
                "://" +
                config.origin +
                "/loadimage/" +
                that.id

          /* setTimeout(function () {
            that.default_height = that.$refs.img.height;
            that.default_width = that.$refs.img.width;
          }, 1000);*/
        }

        if (data.data === false) {
          that.seen = false;
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    notallowed(e) {
      e.preventDefault();
    },
    close() {
      let data = {
        token: cookies.getCookie("token"),
        fileid: this.id,
      };
      this.$socket.emit("deleteblock", data);
      this.seen = false;
    },
    close_box(evt) {
      if (
        evt.target.className === "img" ||
        evt.target.className === "view-file" ||
        evt.target.className === "img-holder" ||
        evt.target.className.baseVal === "close"
      ) {
        let data = {
          token: cookies.getCookie("token"),
          fileid: this.id,
        };
        this.$socket.emit("deleteblock", data);
        this.seen = false;
      }
    },
  },
  computed: {
    imagesFromStore() {
      // console.log(this.$store.getters.DIRECTORY_CHILDREN[this.index]);
      return this.$store.getters.DIRECTORY_CHILDREN.filter((el) =>
        this.isImage(el)
      );
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>
